import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../services/validation.service';
import { LoaderService } from '../../services/Spinner.service';

@Component({
  selector: 'app-resetrpassword',
  templateUrl: './resetpassword.component.html',
  styles: [],
  providers :[SharedService]

})
export class ResetpasswordComponent implements OnInit {
 resetForm: FormGroup;
 successMsg : boolean;
servererrormsg: boolean;
objLoaderStatus: boolean = false;
userErrormsg : boolean;
  constructor(private formBuilder: FormBuilder,private shareService :SharedService,private loaderService :LoaderService) {
   
   }


  ngOnInit() {
   let body = document.getElementsByTagName('body')[0];
   body.classList.remove("zizbackground");
   body.classList.remove("overflow");
    this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
    this.successMsg=false;
    this.servererrormsg=false;
    this.resetForm = this.formBuilder.group({
      email: ['', Validators.compose([ValidationService.emailValidator])]
    });
  }
    onSubmit() {
     this.loaderService.displayLoader(true);
      this.shareService.callApi("auth/forgotPassword",this.resetForm.value).subscribe((result) => {
        this.loaderService.displayLoader(false);
        console.log(result);
       if ((result.data)) {
            this.successMsg = true;
              setTimeout(function () {
            this.successMsg = false;
        }.bind(this), 3000);
      }
      else if(result.meta){
          this.servererrormsg=true;
            setTimeout(function () {
          this.servererrormsg = false;
        }.bind(this), 3000);
        }
       else {
          this.servererrormsg=true;
            setTimeout(function () {
          this.servererrormsg = false;
        }.bind(this), 3000);
        }
         this.loaderService.displayLoader(false);
        //  this.router.navigate(['/signup']);
         
   });

  // ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/resetPassword/resetpassword.component.ts